import React from 'react';
import css from './CircularFlag.module.css';

/**
 * CircularFlag - Displays country flag in circular format
 *
 * @param {Object} props
 * @param {string} props.countryCode - ISO country code (e.g., 'GB', 'US', 'DE')
 * @param {string} props.size - Size variant: 'small', 'medium', 'large'
 */
const CircularFlag = ({ countryCode, size = 'medium' }) => {
  if (!countryCode) return null;

  // Use flagcdn.com for reliable flag images
  const flagUrl = `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;

  const sizeClass = {
    small: css.small,
    medium: css.medium,
    large: css.large,
  }[size] || css.medium;

  return (
    <div className={`${css.flag} ${sizeClass}`}>
      <img
        src={flagUrl}
        alt={`${countryCode} flag`}
        className={css.flagImage}
        onError={(e) => {
          // Fallback to a placeholder or hide if image fails to load
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
};

export default CircularFlag;
